import { createSlice } from '@reduxjs/toolkit';

const FacultyprofileSlice = createSlice({
  name: 'Facultyprofile',
  initialState: {
    facultyprofileData: null,
    facultyprofileExists: false,
    isfacultyProfileAdmin: false,
  },
  reducers: {
    setFacultyProfileData: (state, action) => {
      // Using the correct state keys as per initial state
      state.facultyprofileData = action.payload.facultyprofileData;
      state.facultyprofileExists = action.payload.facultyprofileExists;
      state.isfacultyProfileAdmin = action.payload.isfacultyProfileAdmin;
    },
    resetFacultyProfile: (state) => {
      state.facultyprofileData = null;
      state.facultyprofileExists = false;
      state.isfacultyProfileAdmin = false;
    },
  },
});

export const { setFacultyProfileData, resetFacultyProfile } = FacultyprofileSlice.actions;

export const selectFacultyProfileData = (state) => state.Facultyprofile.facultyprofileData;
export const selectFacultyProfileExists = (state) => state.Facultyprofile.facultyprofileExists;
export const selectIsFacultyProfileAdmin = (state) => state.Facultyprofile.isfacultyProfileAdmin;

export default FacultyprofileSlice.reducer;
